@if (meetingData.meetingLink) {
<app-link-button
    tooltipPosition="bottom" tooltip="Öffnet das Meeting in einem neuen Tab." [href]="meetingData?.meetingLink" target="_blank"
    [label]="label"
    iconRight="pi pi-arrow-up-right" styleClass="p-button-rounded p-button-text p-button-secondary"></app-link-button>
<!-- Copy link -->
<p-button size="small" type="button" pTooltip="Beitrittslink kopieren" tooltipPosition="bottom" icon="pi pi-copy" [rounded]="true" [text]="true"
    severity="secondary" (onClick)="copyToClipboard(meetingData?.meetingLink)"></p-button>
} @else {
<span class="muted">—</span>
}
